<template>
  <b-card class="rounded-xl">
    <modal :show.sync="editModal" header-classes="bg-primary p-3">
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        EDIT IMAGE ORDER
      </h6>
      <EditTagsDetail />
      <template slot="footer">
        <base-button type="primary">SAVE CHANGES</base-button>
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>
    <AddTagsSidebar
      :isSidebarActive="openAddBannerSidebar"
      @closeSidebar="toggleAddBannerSidebar"
    />
    <div class="">
      <div>
        <h2 class="text-2xl font-semibold">
          Order Management
        </h2>
      </div>
      <!-- <base-button outline type="success" class="flex" @click="addBanner">
        <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Add Store
      </base-button> -->
      <!-- <OrderStatus /> -->
    </div>
    <b-input-group class="mt-12">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        placeholder="Enter Search...."
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
        >
          <feather-icon
            class=" cursor-pointer  mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <el-table
      class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
      header-row-class-name="thead-light table-th-color"
      :data="TagsData"
    >
      <el-table-column
        label="Invoice No."
        prop="invoiceno"
        min-width="120px"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.invoiceno }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Order ID"
        prop="orderid"
        min-width="120px"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.orderid }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Customer Name"
        min-width="180px"
        prop="custname"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.custname }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Date" min-width="150px" prop="date" sortable>
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.date }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="Total Amount"
        min-width="150px"
        prop="amount"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.amount }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Order Items"
        min-width="150px"
        prop="orderitems"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.orderitems }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Store Name"
        min-width="150px"
        prop="storename"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.storename }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Ship to" min-width="150px" prop="shipto" sortable>
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.shipto }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Order Status"
        min-width="150px"
        prop="status"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.status }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Invoice"
        min-width="120px"
        prop="downloadInvoice"
        sortable
      >
        <template>
          <p class="cursor-pointer text-blue font-medium underline text-sm">
            <a
              download
              href="https://tinyjpg.com/images/social/website.jpg"
              target="_blank"
            >
              Download
            </a>
          </p>
        </template>
      </el-table-column>
      <el-table-column label="Action" min-width="120px">
        <div class="flex items-center">
          <!-- <div
            class="flex items-center mr-4 cursor-pointer"
            data-toggle="tooltip"
            data-placement="top"
            title="Edit"
          >
            <feather-icon
              @click="editModal = true"
              block
              icon="EditIcon"
              svgClasses="w-5"
            ></feather-icon>
          </div> -->
          <div
            class="flex items-center cursor-pointer "
            data-toggle="tooltip"
            data-placement="top"
            title="Delete"
          >
            <feather-icon
              icon="MinusCircleIcon"
              svgClasses="w-5"
              variant="primary"
            ></feather-icon>
          </div>
        </div>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="10"
        :total="50"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import "../../scss/Index.scss";
import TagsData from "./components/TagsData";
import EditTagsDetail from "./components/EditTagsDetail";
import AddTagsSidebar from "./components/AddTagsSidebar";
import OrderStatus from "./components/OrderStatus";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    EditTagsDetail,
    AddTagsSidebar,
    OrderStatus
  },
  data() {
    return {
      TagsData,
      currentPage: 1,
      editModal: false,
      openAddBannerSidebar: false
    };
  },
  methods: {
    addBanner() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    }
  }
};
</script>
